import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { useRtl as ee } from "../../_mixins/use-rtl.js";
import { checkboxGroupInjectionKey as oe } from "./CheckboxGroup.js";
import ne from "./CheckMark.js";
import re from "./LineMark.js";
import le from "./styles/index.cssr.js";
import de from "../../_mixins/use-config.js";
import ce from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-merged-state.js";
import te from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import ae from "../../_mixins/use-form-item.js";
import M from "../../_mixins/use-theme.js";
import { createKey as z } from "../../_utils/cssr/index.js";
import { useThemeClass as ie } from "../../_mixins/use-css-vars-class.js";
import { createId as se } from "../../../../../../seemly@0.3.10/node_modules/seemly/es/misc/index.js";
import { resolveWrappedSlot as ue } from "../../_utils/vue/resolve-slot.js";
import fe from "../../_internal/icon-switch-transition/src/IconSwitchTransition.js";
import { on as be } from "../../../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { warnOnce as he } from "../../_utils/naive/warn.js";
import me from "../styles/light.js";
import { call as D } from "../../_utils/vue/call.js";
import { defineComponent as ke, watchEffect as ve, inject as ge, computed as $, h as c } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as T, toRef as Ce } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
const xe = Object.assign(Object.assign({}, M.props), {
  size: String,
  checked: {
    type: [Boolean, String, Number],
    default: void 0
  },
  defaultChecked: {
    type: [Boolean, String, Number],
    default: !1
  },
  value: [String, Number],
  disabled: {
    type: Boolean,
    default: void 0
  },
  indeterminate: Boolean,
  label: String,
  focusable: {
    type: Boolean,
    default: !0
  },
  checkedValue: {
    type: [Boolean, String, Number],
    default: !0
  },
  uncheckedValue: {
    type: [Boolean, String, Number],
    default: !1
  },
  "onUpdate:checked": [Function, Array],
  onUpdateChecked: [Function, Array],
  // private
  privateInsideTable: Boolean,
  // deprecated
  onChange: [Function, Array]
}), He = ke({
  name: "Checkbox",
  props: xe,
  setup(o) {
    process.env.NODE_ENV !== "production" && ve(() => {
      o.onChange && he("checkbox", "`on-change` is deprecated, please use `on-update:checked` instead.");
    });
    const l = ge(oe, null), a = T(null), {
      mergedClsPrefixRef: i,
      inlineThemeDisabled: h,
      mergedRtlRef: y
    } = de(o), g = T(o.defaultChecked), C = Ce(o, "checked"), x = ce(C, g), n = te(() => {
      if (l) {
        const e = l.valueSetRef.value;
        return e && o.value !== void 0 ? e.has(o.value) : !1;
      } else
        return x.value === o.checkedValue;
    }), m = ae(o, {
      mergedSize(e) {
        const {
          size: d
        } = o;
        if (d !== void 0)
          return d;
        if (l) {
          const {
            value: r
          } = l.mergedSizeRef;
          if (r !== void 0)
            return r;
        }
        if (e) {
          const {
            mergedSize: r
          } = e;
          if (r !== void 0)
            return r.value;
        }
        return "medium";
      },
      mergedDisabled(e) {
        const {
          disabled: d
        } = o;
        if (d !== void 0)
          return d;
        if (l) {
          if (l.disabledRef.value)
            return !0;
          const {
            maxRef: {
              value: r
            },
            checkedCountRef: t
          } = l;
          if (r !== void 0 && t.value >= r && !n.value)
            return !0;
          const {
            minRef: {
              value: f
            }
          } = l;
          if (f !== void 0 && t.value <= f && n.value)
            return !0;
        }
        return e ? e.disabled.value : !1;
      }
    }), {
      mergedDisabledRef: k,
      mergedSizeRef: p
    } = m, R = M("Checkbox", "-checkbox", le, me, o, i);
    function v(e) {
      if (l && o.value !== void 0)
        l.toggleCheckbox(!n.value, o.value);
      else {
        const {
          onChange: d,
          "onUpdate:checked": r,
          onUpdateChecked: t
        } = o, {
          nTriggerFormInput: f,
          nTriggerFormChange: S
        } = m, b = n.value ? o.uncheckedValue : o.checkedValue;
        r && D(r, b, e), t && D(t, b, e), d && D(d, b, e), f(), S(), g.value = b;
      }
    }
    function s(e) {
      k.value || v(e);
    }
    function V(e) {
      if (!k.value)
        switch (e.key) {
          case " ":
          case "Enter":
            v(e);
        }
    }
    function B(e) {
      switch (e.key) {
        case " ":
          e.preventDefault();
      }
    }
    const I = {
      focus: () => {
        var e;
        (e = a.value) === null || e === void 0 || e.focus();
      },
      blur: () => {
        var e;
        (e = a.value) === null || e === void 0 || e.blur();
      }
    }, N = ee("Checkbox", y, i), w = $(() => {
      const {
        value: e
      } = p, {
        common: {
          cubicBezierEaseInOut: d
        },
        self: {
          borderRadius: r,
          color: t,
          colorChecked: f,
          colorDisabled: S,
          colorTableHeader: b,
          colorTableHeaderModal: _,
          colorTableHeaderPopover: E,
          checkMarkColor: K,
          checkMarkColorDisabled: F,
          border: U,
          borderFocus: O,
          borderDisabled: P,
          borderChecked: j,
          boxShadowFocus: H,
          textColor: A,
          textColorDisabled: L,
          checkMarkColorDisabledChecked: G,
          colorDisabledChecked: W,
          borderDisabledChecked: q,
          labelPadding: J,
          labelLineHeight: Q,
          labelFontWeight: X,
          [z("fontSize", e)]: Y,
          [z("size", e)]: Z
        }
      } = R.value;
      return {
        "--n-label-line-height": Q,
        "--n-label-font-weight": X,
        "--n-size": Z,
        "--n-bezier": d,
        "--n-border-radius": r,
        "--n-border": U,
        "--n-border-checked": j,
        "--n-border-focus": O,
        "--n-border-disabled": P,
        "--n-border-disabled-checked": q,
        "--n-box-shadow-focus": H,
        "--n-color": t,
        "--n-color-checked": f,
        "--n-color-table": b,
        "--n-color-table-modal": _,
        "--n-color-table-popover": E,
        "--n-color-disabled": S,
        "--n-color-disabled-checked": W,
        "--n-text-color": A,
        "--n-text-color-disabled": L,
        "--n-check-mark-color": K,
        "--n-check-mark-color-disabled": F,
        "--n-check-mark-color-disabled-checked": G,
        "--n-font-size": Y,
        "--n-label-padding": J
      };
    }), u = h ? ie("checkbox", $(() => p.value[0]), w, o) : void 0;
    return Object.assign(m, I, {
      rtlEnabled: N,
      selfRef: a,
      mergedClsPrefix: i,
      mergedDisabled: k,
      renderedChecked: n,
      mergedTheme: R,
      labelId: se(),
      handleClick: s,
      handleKeyUp: V,
      handleKeyDown: B,
      cssVars: h ? void 0 : w,
      themeClass: u == null ? void 0 : u.themeClass,
      onRender: u == null ? void 0 : u.onRender
    });
  },
  render() {
    var o;
    const {
      $slots: l,
      renderedChecked: a,
      mergedDisabled: i,
      indeterminate: h,
      privateInsideTable: y,
      cssVars: g,
      labelId: C,
      label: x,
      mergedClsPrefix: n,
      focusable: m,
      handleKeyUp: k,
      handleKeyDown: p,
      handleClick: R
    } = this;
    (o = this.onRender) === null || o === void 0 || o.call(this);
    const v = ue(l.default, (s) => x || s ? c("span", {
      class: `${n}-checkbox__label`,
      id: C
    }, x || s) : null);
    return c("div", {
      ref: "selfRef",
      class: [`${n}-checkbox`, this.themeClass, this.rtlEnabled && `${n}-checkbox--rtl`, a && `${n}-checkbox--checked`, i && `${n}-checkbox--disabled`, h && `${n}-checkbox--indeterminate`, y && `${n}-checkbox--inside-table`, v && `${n}-checkbox--show-label`],
      tabindex: i || !m ? void 0 : 0,
      role: "checkbox",
      "aria-checked": h ? "mixed" : a,
      "aria-labelledby": C,
      style: g,
      onKeyup: k,
      onKeydown: p,
      onClick: R,
      onMousedown: () => {
        be("selectstart", window, (s) => {
          s.preventDefault();
        }, {
          once: !0
        });
      }
    }, c("div", {
      class: `${n}-checkbox-box-wrapper`
    }, " ", c("div", {
      class: `${n}-checkbox-box`
    }, c(fe, null, {
      default: () => this.indeterminate ? c("div", {
        key: "indeterminate",
        class: `${n}-checkbox-icon`
      }, re()) : c("div", {
        key: "check",
        class: `${n}-checkbox-icon`
      }, ne())
    }), c("div", {
      class: `${n}-checkbox-box__border`
    }))), v);
  }
});
export {
  xe as checkboxProps,
  He as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/checkbox/src/Checkbox.js
// module id = 152
// module chunks = 67